import api from "./base";

/**
 * Fetch invoices from the server for a given date range.
 * @param {string} startDate - ISO string (YYYY-MM-DD)
 * @param {string} endDate - ISO string (YYYY-MM-DD)
 * @returns {Promise<Object>} Object containing documents and expenses
 */
export async function fetchInvoices(startDate, endDate) {
    try {
        // Convert timestamps to ISO date strings if needed



        const response = await api.post("/teacher/invoices", {
            startDate,
            endDate,
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching invoices:', error);
        throw error;
    }
}

/**
 * Fetch invoices for the current month.
 * @returns {Promise<Object>} Object containing documents and expenses
 */
export async function fetchCurrentMonthInvoices() {
    const now = new Date();
    const startDate = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().split('T')[0];
    const endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0).toISOString().split('T')[0];

    return fetchInvoices(startDate, endDate);
} 